import { ReviewExtraModel, IReview } from "@core/models";
import { DEMAND_TYPES } from "@core/constants";

export const ReviewExtraModelMock = new ReviewExtraModel({
  [IReview.extraId]: "123",
  [IReview.firstname]: "Jean",
  [IReview.lastname]: "Bon",
  [IReview.qualification]: "Serveur",
  [IReview.note]: "4",
  [IReview.photo]: "https://picsum.photos/id/1005/600/600",
  [IReview.demandType]: DEMAND_TYPES.AE,
  [IReview.demandId]: "456",
  [IReview.start]: "2023-01-01T08:00:00+01:00",
  [IReview.end]: "2023-01-01T18:00:00+01:00",
});
